import React, { useMemo } from 'react';
import styled from 'styled-components';
import { InlineInputCardWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';
import { MonacoEditor } from '@/features/editor/widgets/code-editors/monaco-editor';

export interface GenericJsObjectInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function GenericJsObjectInput({
  value,
  onChange,
}: GenericJsObjectInputProps) {
  const height = useMemo(() => {
    const lineCount = value.split(`\n`).length;
    const height = 25 * lineCount;
    if (height < 100) return 100;
    if (height > 400) return 400;
    return height;
  }, [value]);

  return (
    <Wrapper>
      <Container height={height}>
        <MonacoEditor
          code={value}
          onCodeChange={onChange}
          lang="json"
          readOnly={false}
          autoFormat
          monacoOptions={{
            lineNumbers: `off`,
            minimap: {
              enabled: false,
            },
            background: `transparent`,
            fontSize: 18,
            fontFamily: `JetBrains Mono`,
            scrollBeyondLastLine: false,
            scrollbar: { alwaysConsumeMouseWheel: false },
            automaticLayout: true,
          }}
        />
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled(InlineInputCardWrapper)`
  && {
    padding: 2.4rem 0;
  }
`;

const Container = styled.div`
  height: ${(props) => props?.height || 75}px;
  width: 100%;

  .monaco-editor,
  .monaco-editor-background,
  .monaco-editor .margin {
    background-color: transparent !important;
  }
`;
